import { DocumentData, QueryDocumentSnapshot } from "@angular/fire/firestore"
import { OperatorFunction, map } from "rxjs"

export function mapToEntities<T>(): OperatorFunction<QueryDocumentSnapshot<DocumentData>[], T[]> {
  return map<DocumentData[], T[]>((value: DocumentData[]) => value.map(c => ({ id: c['id'], ...c['data']() } as T)))
}
